import './highlight';
import ReactQuill from 'react-quill';
//
import { FC, LegacyRef } from 'react';
import { useTranslation } from 'react-i18next';
import { EditorProps } from './types';
import { StyledEditor } from './styles';
import EditorToolbar, { formats } from './EditorToolbar';

const Editor: FC<EditorProps> = ({
  id = 'minimal-quill',
  error,
  value,
  onChange,
  simple = false,
  helperText,
  sx,
  quillRef,
  ...other
}) => {
  const { t } = useTranslation('schedule');
  const modules = {
    toolbar: {
      container: `#${id}`,
    },
    history: {
      delay: 500,
      maxStack: 100,
      userOnly: true,
    },
    syntax: true,
    clipboard: {
      matchVisual: false,
    },
  };

  return (
    <>
      <StyledEditor
        sx={{
          ...(error && {
            border: (theme) => `solid 1px ${theme.palette.error.main}`,
          }),
          ...sx,
        }}
      >
        <EditorToolbar id={id} isSimple={simple} />

        <ReactQuill
          ref={quillRef as LegacyRef<ReactQuill> | undefined}
          value={value}
          onChange={onChange}
          modules={modules}
          formats={formats}
          placeholder={`${t('writeANote')}...`}
          {...other}
        />
      </StyledEditor>

      {helperText && helperText}
    </>
  );
};

export {
  Editor,
};
